<template>
  <custom-dialog width="1000px" :title="model.title" :visible="visible" v-on="$listeners" class="contract-deviceSelect-dialog">
    <div class="dialog-body" style="padding-top: 0">
      <div class="search-hd">
        <el-form :inline="true">
          <el-form-item style="float: left">
            <custom-date-picker
              v-model="rentalStartTime"
              type="date"
              align="right"
              value-format="YYYY-MM-DD HH:mm:ss"
              default-time="00:00:00"
              :picker-options="pickerOptionDay"
              style="width: 100%"
              :placeholder="$t('crm_contract_deviceSelect_dialog.qi_zu_ri_qi')"
            ></custom-date-picker>
          </el-form-item>
          <el-form-item style="float: right; margin-right: 0">
            <search-input v-model="formSearch.search" :placeholder="$t('crm_contract_deviceSelect_dialog.ji_shen_hao')" @fetch="onPageChange({ page: 1 })" style="float: right"></search-input>
          </el-form-item>
          <el-form-item style="float: right">
            <switch-button :link="$refs.container"></switch-button>
          </el-form-item>
        </el-form>
      </div>
      <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
        <el-form :inline="true" label-position="top">
          <el-form-item :label="$t('crm_contract_deviceSelect_dialog.chan_pin_xing_hao')">
            <custom-select url="productCodeSelectList" v-model="formSearch.productCode" :props="{ label: 'productCode', value: 'productCode' }" width="100%"></custom-select>
          </el-form-item>
        </el-form>
      </switch-container>
      <custom-table
        type="checkbox"
        tableCode="contract_device_select"
        v-model="tableSelect"
        @column="setColumn"
        :data="tableList"
        @filter="filterChange"
        @sort="sortChange"
        :slots="['rentalTerm']"
        height="500px"
      >
        <template slot="rentalTerm" slot-scope="scope">{{ scope.row.rentalTerm }}{{ getDicValue('rental_term_unit', scope.row.rentalTermUnit) }}</template>
      </custom-table>
      <div class="table-page">
        <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" @click="chooseDevice" :disabled="!tableSelect.length">{{ $t('Common.com_confirm') }}</el-button>
    </div>
    <!-- 租赁确认单 -->
    <contract-lease-confirmed v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false"></contract-lease-confirmed>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';
import moment from 'moment';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';
import contractLeaseConfirmed from '@/pages/crm/components/contractConfirmDownload.vue';

export default {
  mixins: [dialogMixins, resetFormSearchMixins],
  components: {
    contractLeaseConfirmed,
  },
  data() {
    return {
      visible: true,
      tableList: [],
      totalRows: 0,
      rentalStartTime: '',
      tableSelect: [],

      formSearch: {
        bizId: '',
        bizType: '',
        parentId: '',
        isAss: 0,
        search: '',
        orderBy: '',
        orderType: '',
        pageSize: 50,
        pageNum: 1,
        deviceState: '15,21,22', // 15-在途中，21-待启租，22-租赁中，
        productCode: '',
        orgType: '',
        orgName: '',
        locationName: '',
        contractNo: '',
      },
      dialogVisible: false,
      dialogModel: {},
    };
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.formSearch.bizId = this.model.bizId;
      this.getDeviceList();
    },
    // 获取设备列表
    getDeviceList: function () {
      this.$getJSON(apis.ContractDevicePage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getDeviceList();
    },
    // 关联设备
    chooseDevice: function () {
      //
      let hasWqz = false;
      let hasZlz = false;
      const rentDateArr = [];
      this.tableSelect.forEach((i) => {
        if (`${i.bizState}` === '15' || `${i.bizState}` === '21') {
          hasWqz = true;
        }
        if (`${i.bizState}` === '22') {
          hasZlz = true;
          this.rentalStartTime = i.rentalStartTime;
          // 判断是不是同一天 不是就push
          if (!moment(this.$momentElLocal(this.rentalStartTime)).isSame(moment(this.$momentElLocal(i.rentalStartTime)), 'day')) {
            rentDateArr.push(i.rentalStartTime);
          }
        }
      });
      const rentDates = [...rentDateArr];
      if ((hasWqz && hasZlz) || (hasZlz && rentDates.length > 1)) {
        const tips = this.$t('crm_contract_deviceSelect_dialog.znxzdswqzhzrqstytdsb');
        this.$message.error(tips);
        return '';
      }
      if (this.rentalStartTime === '') {
        const tips = this.$t('crm_contract_deviceSelect_dialog.qnxzqzsj');
        this.$message.error(tips);
        return '';
      }

      this.dialogVisible = true;
      this.dialogModel.title = this.$t('crm_contract_deviceSelect_dialog.dyzlqrd');
      this.dialogModel.row = this.tableSelect;
      this.dialogModel.rentalStartTime = this.rentalStartTime;
      this.dialogModel.bizId = this.model.bizId;
      this.dialogModel.bizClass = this.model.bizClass;
      this.dialogModel.type = this.model.type;
      return '';
    },
  },
};
</script>

<style lang="scss">
</style>
